import { lazy } from 'react'
import type { Routes } from '@/@types/routes'

const authRoute: Routes = [
    {
        key: 'signUp',
        path: `/sign-up`,
        component: lazy(() => import('@/components/pages/auth/SignUp/SignUp')),
        authority: [],
    },
    {
        key: 'forgotPassword',
        path: `/forgot-password`,
        component: lazy(() => import('@/components/pages/auth/ForgotPassword')),
        authority: [],
    },
    {
        key: 'resetPassword',
        path: `/reset-password`,
        component: lazy(() => import('@/components/pages/auth/ResetPassword')),
        authority: [],
    },
]

export default authRoute
